import { useFormikContext } from 'formik'
import { Typography } from '@mui/material'

import { HelperWrapper } from 'src/components'
import { AccountSwitchButton } from '../accaunt-switch'

import { IAccountJourneySettings, EDefaultLandingPage } from 'src/types'
import { useStyles } from '../styles'

interface IProps {
  mobile?: boolean
  handleChange: (value: EDefaultLandingPage) => void
}

export const DefaultLandingPageSettings = ({ mobile, handleChange }: IProps) => {
  const { isSubmitting, values } = useFormikContext<IAccountJourneySettings>()

  const classes = useStyles({ mobile })

  return (
    <>
      <Typography variant="h4" fontSize={15} fontWeight={600}>
        <HelperWrapper t="account-settings-default-landing-page-label" />
      </Typography>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="default_landing_page_home"
          disabled={isSubmitting}
          checked={values.default_landing_page === EDefaultLandingPage.HOME}
          handleChange={() => handleChange(EDefaultLandingPage.HOME)}
          lable={<HelperWrapper t="account-settings-default-landing-home-label" />}
          exclusiveGroup="defaultLandingPage"
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="default_landing_page_journey"
          disabled={isSubmitting}
          checked={values.default_landing_page === EDefaultLandingPage.JOURNEY}
          handleChange={() => handleChange(EDefaultLandingPage.JOURNEY)}
          lable={<HelperWrapper t="account-settings-default-landing-journey-label" />}
          exclusiveGroup="defaultLandingPage"
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="default_landing_page_impact"
          disabled={isSubmitting}
          checked={values.default_landing_page === EDefaultLandingPage.IMPACT}
          handleChange={() => handleChange(EDefaultLandingPage.IMPACT)}
          lable={<HelperWrapper t="account-settings-default-landing-impact-label" />}
          exclusiveGroup="defaultLandingPage"
        />
      </div>
      <div className={classes.settingsItem}>
        <AccountSwitchButton
          mobile={mobile}
          name="default_landing_page_account"
          disabled={isSubmitting}
          checked={values.default_landing_page === EDefaultLandingPage.ACCOUNT}
          handleChange={() => handleChange(EDefaultLandingPage.ACCOUNT)}
          lable={<HelperWrapper t="account-settings-default-landing-account-label" />}
          exclusiveGroup="defaultLandingPage"
        />
      </div>
    </>
  )
}
